import { TicketFilterState, UNASSIGNED_ASSIGNEE } from './ticketFilterUtils'

export const BUILT_IN_TICKET_VIEWS = [
  { id: 'all', label: 'All tickets' },
  { id: 'my-assigned', label: 'My assigned', staffOnly: true },
  { id: 'unassigned', label: 'Unassigned', staffOnly: true },
  { id: 'pending-closure', label: 'Pending closure' },
  { id: 'urgent-high', label: 'Urgent & high' },
] as const

export type BuiltInTicketViewId = (typeof BUILT_IN_TICKET_VIEWS)[number]['id']

export function isBuiltInTicketViewId(value: string): value is BuiltInTicketViewId {
  return BUILT_IN_TICKET_VIEWS.some(view => view.id === value)
}

export interface BuiltInViewContext {
  userId?: string
  statusIdByName: Record<string, string>
}

/** Filter fields applied by a built-in view (display prefs are left unchanged). */
export function getBuiltInViewFilterPatch(
  viewId: BuiltInTicketViewId,
  ctx: BuiltInViewContext
): Pick<
  TicketFilterState,
  | 'selectedStatuses'
  | 'selectedPriorities'
  | 'selectedDepartments'
  | 'selectedSources'
  | 'selectedAssignees'
  | 'selectedClientOrgs'
  | 'selectedClientUsers'
  | 'tagSearch'
  | 'createdFrom'
  | 'createdTo'
  | 'estimatedHoursFilter'
> {
  const empty = {
    selectedStatuses: [] as string[],
    selectedPriorities: [] as string[],
    selectedDepartments: [] as string[],
    selectedSources: [] as string[],
    selectedAssignees: [] as string[],
    selectedClientOrgs: [] as string[],
    selectedClientUsers: [] as string[],
    tagSearch: '',
    createdFrom: '',
    createdTo: '',
    estimatedHoursFilter: 'all' as const,
  }

  switch (viewId) {
    case 'all':
      return empty
    case 'my-assigned':
      return {
        ...empty,
        selectedAssignees: ctx.userId ? [ctx.userId] : [],
      }
    case 'unassigned':
      return {
        ...empty,
        selectedAssignees: [UNASSIGNED_ASSIGNEE],
      }
    case 'pending-closure': {
      const pendingId = ctx.statusIdByName.pending_closure
      return {
        ...empty,
        selectedStatuses: pendingId ? [pendingId] : [],
      }
    }
    case 'urgent-high':
      return {
        ...empty,
        selectedPriorities: ['urgent', 'high'],
      }
    default:
      return empty
  }
}
